import { trackSegmentEvent } from "shared/Analytics";

type AccountMarkedForDeletionProps = {
  reason: string;
  additionalFeedback: string;
};

export const trackAccountMarkedForDeletion = ({
  reason,
  additionalFeedback,
}: AccountMarkedForDeletionProps) => {
  trackSegmentEvent("Account Marked for Deletion", {
    reason,
    additionalFeedback,
  });
};
